module.exports = __webpack_public_path__ + "static/media/previous_order.9478b961.svg";